import * as models from 'smg/admin/models';
import { ClearCache } from 'smg/admin/session';
import { PinOnNextLoad } from '../accounts';
import axios, { AxiosStatusCode } from 'smg/axios';
import { Start, Stop } from 'smg/buttons';
import { SetLoginToken } from 'smg/customer-api/session';
import { ShowError } from 'smg/errors';
import QueryString from 'smg/querystring';
import { Relref } from '../hugo';
import { SafeReturnURL } from '../url';

function main() {
    const form = document.querySelector('#login-form') as HTMLElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const email = form.querySelector('#user-email') as HTMLInputElement;
    const password = form.querySelector('#user-password') as HTMLInputElement;
    const loginBtn = form.querySelector('#submit-btn') as HTMLButtonElement;

    form.addEventListener('submit', async e => {
        e.preventDefault();
        fieldset.disabled = true;
        Start(loginBtn);

        await axios.post('/v2/sessions', {
            'email': email.value,
            'password': password.value,
        }).then(resp => {
            // ClearCache() changes the cache param, which skips the server's
            // one-minute session cache (smg.SessionUser) and drops the login
            // token ts/axios.ts cached for the previous account.
            ClearCache();
            const created = models.SessionCreateResponse.fromJSON(resp.data);
            if (created.token) {
                SetLoginToken(created.token);
            }
            // A login is an explicit account action — the landing page pins
            // this tab to the freshly signed-in account.
            PinOnNextLoad();
            window.location.href = SafeReturnURL(QueryString().get('return'), Relref('/'));
        }).catch(err => {
            Stop(loginBtn);
            fieldset.disabled = false;

            if (AxiosStatusCode(err) === 400) {
                const alert = document.querySelector('#incorrect-login-info') as HTMLElement;
                alert.classList.remove('d-none');
            } else {
                ShowError(err);
            }
        });
    });
}

main();
